module.exports = "<footer class=\"app-footer\">\n  <span class=\"ml-auto\">Powered by <a href=\"http://simplifii.com\">Simplifii</a></span>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// /home/ashutosh/submission/src/app/dashboardcomponents/app-footer/app-footer.component.html
// module id = ../../../../../src/app/dashboardcomponents/app-footer/app-footer.component.html
// module chunks = main